import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { QuantitySelector } from '@/components/product/QuantitySelector';
import { formatPrice } from '@/lib/pricing';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

export function CartItem({ item, onUpdateQuantity, onRemove }) {
  const itemTotal = item.price * item.quantity;

  return (
    <div className="flex gap-4 py-4 border-b last:border-b-0">
      {/* 商品圖片 */}
      <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-gray-100">
        <img
          src={item.image || '/placeholder.jpg'}
          alt={item.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* 商品資訊 */}
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-gray-900 truncate">{item.shortName}</h3>
        <p className="text-sm text-gray-500 mb-2">SKU: {item.sku}</p>
        
        <div className="flex items-center justify-between">
          <QuantitySelector
            value={item.quantity}
            onChange={(newQuantity) => onUpdateQuantity(item.id, newQuantity)}
            min={1}
            max={99}
          />
          
          <div className="text-right">
            <div className="text-sm text-gray-500">
              {formatPrice(item.price)} × {item.quantity}
            </div>
            <div className="font-semibold text-gray-900">
              {formatPrice(itemTotal)}
            </div>
          </div>
        </div>
      </div>

      {/* 刪除按鈕 */}
      <div>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="ghost" size="icon" className="text-red-600 hover:text-red-700 hover:bg-red-50">
              <Trash2 className="h-4 w-4" />
              <span className="sr-only">移除商品</span>
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>確認移除商品？</AlertDialogTitle>
              <AlertDialogDescription>
                確定要將「{item.shortName}」從購物車中移除嗎？
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>取消</AlertDialogCancel>
              <AlertDialogAction onClick={() => onRemove(item.id)}>
                確認移除
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
}
